import * as React from "react";
import { connect, MapStateToProps } from "react-redux";
import { ShipmentReviewGrid } from "components/shipment-review/shipment-review-grid";
import { Schema } from "types/schema";
import { postToTopIframe, postToWindow } from "helpers/window-messages";
import { IStore } from "reducers";
import { SHIPMENT_QUANTITY_MODAL } from "constants/cart";
import type { IScope } from "reducers/scope";
import { IOrderData } from "types/cart/shipment-review";
import { IViewDefinition } from "types/view-definitions";

interface IOwnProps {
    orderData: IOrderData;
    productSchema: Schema;
    itemView: IViewDefinition;
    editable: boolean;
}

interface IStateProps {
    scope: IScope;
}

const ShipmentReviewContainer: React.FunctionComponent<IOwnProps & IStateProps> = ({
    orderData,
    itemView,
    productSchema,
    editable,
    scope,
}) => {
    const openSizingGrid = React.useCallback(
        (items, open?: boolean) =>
            postToTopIframe({
                action: SHIPMENT_QUANTITY_MODAL,
                payload: {
                    open: open ?? undefined,
                    data: {
                        ...items,
                        currencyCode: orderData?.currency?.wholesale?.code,
                    },
                },
            }),
        [orderData?.currency]
    );

    const viewLineItem = React.useCallback((lineItemId: string) => {
        postToWindow({
            action: "shipment-review:view-line-item",
            lineItemId,
        });
    }, []);

    return (
        orderData && (
            <ShipmentReviewGrid
                orderData={orderData}
                productSchema={productSchema}
                itemView={itemView}
                openSizingGrid={openSizingGrid}
                viewLineItem={viewLineItem}
                editable={editable}
                scope={scope}
            />
        )
    );
};

const mapStateToProps: MapStateToProps<IStateProps, IOwnProps> = (state: IStore): IStateProps => ({
    scope: state.scope,
});

export default connect<IStateProps, null, IOwnProps>(mapStateToProps)(ShipmentReviewContainer);
